<template>
  <div :class="`m-mobile m-mobile-${routeType}-main mobile-readzhuzi`">
    <div class="mobile-readzhuzi-container">
      <div class="culture">
        <h1>朱子文化</h1>
        <div class="item-container">
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="handleListIframe('zhuzizhangguan')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuzizhanguan.png" />
                </div>
                <div class="item-name">
                  <p>朱子展馆</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','whyc')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuziyicun.png" />
                </div>
                <div class="item-name">
                  <p>朱子遗存</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','zzgs')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuzigushi.png" />
                </div>
                <div class="item-name">
                  <p>朱子故事</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','zzsl')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuzisili.png" />
                </div>
                <div class="item-name">
                  <p>朱子四礼</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="handleList('single-article','song')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuzizhige.png" />
                </div>
                <div class="item-name">
                  <p>朱子之歌</p>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div @click="handleList('article','whjt')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/zhuzijiangtan.png" />
                </div>
                <div class="item-name">
                  <p>朱子讲坛</p>
                </div>
              </div>
            </el-col> -->
            <el-col :span="6">
              <div @click="handleList('article','yjcg')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/yanjiuchengguo.png" />
                </div>
                <div class="item-name">
                  <p>研究成果</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','bhjs')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/baohujianshe.png" />
                </div>
                <div class="item-name">
                  <p>保护建设</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <div @click="handleList('article','cjdz')">
                  <div class="item-grid">
                    <img src="../../assets/mobile/icon/zhuanjidazuo.png" />
                  </div>
                  <div class="item-name">
                    <p>传纪大作</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="handleList('article','mwsh')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/meiwenshuhua.png" />
                </div>
                <div class="item-name">
                  <p>美文书画</p>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div @click="handleList('single-article','map')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/wenhuaditu.png" />
                </div>
                <div class="item-name">
                  <p>文化地图</p>
                </div>
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>
      <div class="travel">
        <h1>朱子旅游</h1>
        <div class="item-container">
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="handleList('destinations','spot')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/jingdian.png" />
                </div>
                <div class="item-name">
                  <p>景点</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleListIframe('hotel')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/jiudian.png" />
                </div>
                <div class="item-name">
                  <p>酒店</p>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div @click="handleListIframe('ticket')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/menpiao.png" />
                </div>
                <div class="item-name">
                  <p>门票</p>
                </div>
              </div>
            </el-col> -->
            <el-col :span="6">
              <div @click="handleList('merchant','food')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/meishi.png" />
                </div>
                <div class="item-name">
                  <p>美食</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','720')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/quanjingtupian.png" />
                </div>
                <div class="item-name">
                  <p>全景浏览</p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div @click="handleList('article','vr')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/quanjingshipin.png" />
                </div>
                <div class="item-name">
                  <p>全景视频</p>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div @click="handleList('article','yjgl')">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/youjigonglue.png" />
                </div>
                <div class="item-name">
                  <p>游记攻略</p>
                </div>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <div @click="handleXCGH()">
                <div class="item-grid">
                  <img src="../../assets/mobile/icon/xingchengguihua.png" />
                </div>
                <div class="item-name">
                  <p>行程规划</p>
                </div>
              </div>
            </el-col> -->
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
require("../../styles/mobile/mobile-arti-main.scss");
export default {
  data() {
    return {
      routeType: "arti"
    };
  },
  methods: {
    handleListIframe(type){
      var _module;
      var _field;
      if(type==='hotel'){
        _module='hotel';
         _field='hotel';
      }
      else if(type==='zhuzizhangguan'){
         _module='zhuzizhangguan';
         _field='zhuzizhangguan';
      }
      else{
        _module='ticket';
         _field='ticket';
      }
      this.$router.push({ path: `/mobile/arti/list/${_module}/${_field}` });
    },
    handleList(_module, _field) {
      if(_module==="single-article"){
        this.$router.push({ path: `/mobile/arti/detail/${_module}/${_field}_detail/1` });
      }
      else{
        this.$router.push({ path: `/mobile/arti/page/${_module}/${_field}` });
      }
    },
    handleXCGH() {
      this.$router.push({
        path: "/travel-list"
      });
      return;
    }
  },
  components: {},
  created() {
    this.$menuFn.setTitle("品朱子");
  },
  watch: {
    $route: function(to, from) {
      if (to.name === "mobile-arti-main") {
        this.$menuFn.setTitle("品朱子");
      }
    }
  }
};
</script>